<template>
  <div class="row">
    <div class="col-md-12 mb-3">
      <router-link to="/principal/roles/add" class="btn btn-secondary" v-if="$can('create', 'Roles')">
        Agregar Rol
      </router-link>
    </div>
    <div class="col-md-12">
      <vue-good-table
        mode="remote"
        :columns="columns"
        :rows="rows"
        :totalRows="totalRecords"
        :sort-options="{
          enabled: true,
        }"
        :isLoading.sync="isLoading"
        styleClass="vgt-table bordered"
        :pagination-options="{
          enabled: true,
          mode: 'registros',
          position: 'top',
          perPage: 10,
          nextLabel: 'siguiente',
          prevLabel: 'anterior',
          rowsPerPageLabel: 'Filas por página',
          ofLabel: 'de',
          pageLabel: 'páginas', // for 'pages' mode
          allLabel: 'Todos',
        }"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'actions'">
            <button v-if="$can('config', 'Roles')" type="button" class="btn btn-secondary" @click="configRole(props)">
              <font-awesome-icon :icon="['fa', 'sliders-h']"/>
            </button>
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'

export default {
  mixins: [formatData],
  components: {
    VueGoodTable
  },
  data () {
    return {
      rows: [],
      isLoading: false,
      totalRecords: 0,
      serverParams: {
        function: 'getRoles',
        columnFilters: {},
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 10
      },
      columns: [
        {
          label: 'Rol',
          field: 'role',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Descripcion',
          field: 'description',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Usuarios Asignados',
          field: 'users',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Modulos Asignados',
          field: 'modules',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Acciones',
          field: 'actions',
          sortable: false
        }
      ]
    }
  },
  methods: {
    deleteRole (row) {
      alert(`work in progress ${JSON.stringify(row)}`)
    },
    configRole (props) {
      this.$router.push({ name: 'rolesEdit', params: props })
    },
    updateParams (newProps) {
      this.serverParams = Object.assign({ page: 0 }, this.serverParams, newProps)
    },
    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange (params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field
        }
      })
      this.loadItems()
    },
    onColumnFilter (params) {
      this.updateParams(params)
      this.loadItems()
    },
    async loadItems (first = false) {
      try {
        // const params = await this.toFormData(this.serverParams)
        const response = await axiosAdelaService.post('/getRoles')
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          this.rows = response.data.rows
        }
      } catch (error) {
        this.showError('No se pudieron obtener los usuarios intentalo mas tarde.')
      }
    }
  },
  async mounted () {
    this.loadItems(true)
  }
}
</script>

<style>

</style>
